import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { updatePartenaire } from "../../../services/partenairesServices";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditPartenaireModal = ({
  isActive,
  onClose,
  partenaireData,
  refreshPartenaires,
}) => {
  const [formData, setFormData] = useState({
    nom: "",
    photo_url: "",
    link_url: "",
    is_detail: false,
    tel: "",
    adresse: "",
    Mail: "",
    photo2_url: "",
    description2: "",
    photo3_url: "",
    description3: "",
    is_active: true,
    ordre: 0,
  });

  useEffect(() => {
    if (partenaireData) {
      setFormData(partenaireData);
    }
  }, [partenaireData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updatePartenaire(partenaireData.id, formData);
      toast.success("Partenaire mis à jour avec succès");
      onClose();
      refreshPartenaires();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du partenaire", error);
      toast.error("Erreur lors de la mise à jour du partenaire");
    }
  };

  if (!isActive) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="modal-box bg-white dark:bg-slate-400 p-4 rounded-lg shadow-lg max-w-2xl w-full max-h-[95vh] overflow-y-auto">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center bg-primary text-white rounded-md">
          Modifier Partenaire
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            className="input input-bordered w-full"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            required
            placeholder="Nom du partenaire"
          />
          <input
            type="text"
            className="input input-bordered w-full"
            name="photo_url"
            value={formData.photo_url}
            onChange={handleChange}
            placeholder="URL du logo principal"
          />
          <input
            type="text"
            className="input input-bordered w-full"
            name="link_url"
            value={formData.link_url}
            onChange={handleChange}
            placeholder="URL du site web"
          />
          <label className="flex items-center space-x-2">
            <span className="label-text">Page Détail ?</span>
            <input
              type="checkbox"
              className="toggle toggle-primary"
              name="is_detail"
              checked={formData.is_detail}
              onChange={handleChange}
            />
          </label>
          <input
            type="text"
            className="input input-bordered w-full"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
            placeholder="Téléphone"
          />
          <input
            type="text"
            className="input input-bordered w-full"
            name="Mail"
            value={formData.Mail}
            onChange={handleChange}
            placeholder="Email"
          />
          <input
            type="text"
            className="input input-bordered w-full"
            name="adresse"
            value={formData.adresse}
            onChange={handleChange}
            placeholder="Adresse"
          />
          <input
            type="text"
            className="input input-bordered w-full"
            name="photo2_url"
            value={formData.photo2_url}
            onChange={handleChange}
            placeholder="URL de la photo 2"
          />
          <div>
            <label className="block mb-1">Description 2</label>
            <ReactQuill
              theme="snow"
              value={formData.description2}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, description2: value }))
              }
            />
          </div>
          <input
            type="text"
            className="input input-bordered w-full"
            name="photo3_url"
            value={formData.photo3_url}
            onChange={handleChange}
            placeholder="URL de la photo 3"
          />
          <div>
            <label className="block mb-1">Description 3</label>
            <ReactQuill
              theme="snow"
              value={formData.description3}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, description3: value }))
              }
            />
          </div>
          <input
            type="number"
            className="input input-bordered w-full"
            name="ordre"
            value={formData.ordre}
            onChange={handleChange}
            placeholder="Ordre d'affichage"
          />
          <label className="flex items-center space-x-2">
            <span className="label-text">Actif ?</span>
            <input
              type="checkbox"
              className="toggle toggle-primary"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
          </label>
          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPartenaireModal;
